/**
 * CheckIcon component displays a checkmark icon.
 *
 * @component
 * @param {Object} props - The component props.
 * @param {number} [props.size] - The size of the icon. Defaults to 20.
 * @param {string} [props.color] - The color of the icon. Defaults to "#16161E".
 * @returns {JSX.Element} - The rendered CheckIcon component.
 */
const CheckIcon = ({ size, color }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size ?? "20"}
      height={size ?? "20"}
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.7071 5.29289C17.0976 5.68342 17.0976 6.31658 16.7071 6.70711L8.70711 14.7071C8.31658 15.0976 7.68342 15.0976 7.29289 14.7071L3.29289 10.7071C2.90237 10.3166 2.90237 9.68342 3.29289 9.29289C3.68342 8.90237 4.31658 8.90237 4.70711 9.29289L8 12.5858L15.2929 5.29289C15.6834 4.90237 16.3166 4.90237 16.7071 5.29289Z"
        fill={color ?? "#16161E"}
      />
    </svg>
  );
};

export default CheckIcon;
